module.exports = __webpack_public_path__ + "static/media/bbbb.13626135.gif";